import React from "react";
import './monitoring.css';
import LayoutMain from "../../Elements/LayoutMain/LayoutMain";

function TisMonitoringSourceGatsby (props) {
        function TextSource(info) {let InText = '*undefined';if (props.Adminka) {try {InText = JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] ? JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] : '*'+info.children}   catch (err) {InText = '*'+info.children}return <TextChange update={props.updateData} Text={InText} ArrIndex={info.ArrIndex} lang={props.lang} Adminka={true}/>
        } else {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*'+info.children}</>}   catch (err) {return <>*{info.children}</>}}}

        return (
    <LayoutMain title={props.title} description={props.description} lang={props.lang}  AllMenu={['','','ElementMenuActive','','','']} Active={2}>
        <main className="InvestingRating StandartPage">
            <div className="StandartIn">

                <iframe src={'https://my.profiforex.com/iframe/tis/monitoring/?lang='+props.lang} name="tis"  title='Profiforex ForexRating' className="autoHeight-iframe" width="100%" height="800"/>
            </div>
        </main>
    </LayoutMain>
)}

export default TisMonitoringSourceGatsby